import React from 'react';
import { LEAD_STAGES, LeadStages } from 'models/Lead';
import AcceptStateActions from './AcceptStepActions';
import { EnquiryStepActions } from './EnquiryStepActions';
import { ProspectStepActions } from './ProspectStepActions';
import { BidderStepActions } from './BidderStepActions';

export const USER_ACTIONS: Record<LeadStages, React.FC> = {
  [LEAD_STAGES.ENQUIRE]: EnquiryStepActions,
  [LEAD_STAGES.ACCEPT]: AcceptStateActions,
  [LEAD_STAGES.CONFIRM]: ProspectStepActions,
  [LEAD_STAGES.OFFER]: BidderStepActions,
} as const;
